import { render, staticRenderFns } from "./typeBro.vue?vue&type=template&id=0fd5b92b&scoped=true"
import script from "./typeBro.vue?vue&type=script&lang=js"
export * from "./typeBro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5b92b",
  null
  
)

export default component.exports